<template>
  <v-flex xl4 md7 sm9 xs12>
    <page-toolbar>
      <kendo-button icon="add" title="Add new register" v-show="editable" @click="edit = true">
      </kendo-button>
      <div ref="curveNameDropDownList" style="width: 200px"></div>
      <div v-show="edit" style="display: inline-flex">
        <kendo-datepicker
          required
          :disable-dates="disableDates"
          format="yyyy-MM-dd"
          v-model="selectedDate"
          style="width: 120px;"
        />
        <kendo-button icon="check" title="save" v-show="editable" @click="saveNew"> </kendo-button>
        <kendo-button icon="cancel" title="cancel" v-show="editable" @click="edit = false">
        </kendo-button>
      </div>
      <div v-show="!edit">
        <div ref="evaluationDateDropDownList" style="width: 120px"></div>
        <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
        <kendo-button icon="delete" title="Delete register" v-show="editable" @click="deleteItem">
        </kendo-button>
      </div>
    </page-toolbar>
    <div v-if="loading">Loading...</div>
    <kendo-grid
      v-else
      height="calc(100vh - 165px)"
      :dataSource="gridDataSource"
      :toolbar="[]"
      ref="grid"
      :filterable="true"
      :editable="editable && 'inline'"
      :sortable="true"
      :pageable-always-visible="false"
      :columns="columns"
    />
  </v-flex>
</template>
<script>
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
import {numericEditor} from '@/helpers/kendo-editors'
import notification from '@/helpers/notification'
import axios from 'axios'
const $ = kendo.jQuery
export default {
  computed: {
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    editable() {
      return this.role != 'Guest'
    },
  },
  components: {
    PageToolbar,
  },
  async mounted() {
    await this.createCurveNameDropDown()
    await this.createEvaluationDateDropDown()
    this.loading = false
  },
  data() {
    return {
      loading: true,
      curveId: -1,
      evaluationDate: null,
      edit: false,
      selectedDate: null,
      curveDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/CreditSpread/getCurves',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      evaluationDateDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/CreditSpread/getEvaluationDates',
            contentType: 'application/json',
            data: () => ({curveId: this.curveId}),
            type: 'GET',
          },
        },
      }),
      gridDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/CreditSpread',
            contentType: 'application/json',
            data: () => ({curveId: this.curveId, evaluationDateOa: this.evaluationDate}),
            type: 'GET',
          },
          update: {url: '/api/heroux/CreditSpread', type: 'PUT'},
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'creditSpreadValueId',
            fields: {
              creditSpreadValueId: {type: 'number'},
              creditSpreadId: {type: 'number'},
              curveId: {type: 'number'},
              evalDate: {type: 'date'},
              tenor: {type: 'string', editable: false},
              value: {type: 'number', editable: true},
            },
          },
        },
      }),
      columns: [
        {
          command: 'edit',
          title: '&nbsp;',
          width: 70,
          attributes: {style: 'text-align: center;'},
        },
        {
          field: 'tenor',
          title: 'Tenor',
          width: 130,
        },
        {
          field: 'value',
          title: 'Spread(%)',
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}%',
          editor: numericEditor(
            {
              decimals: 5,
              format: '{0:n5}',
              spinners: false,
            },
            true,
          ),
        },
      ],
    }
  },
  methods: {
    async saveNew() {
      if (this.selectedDate == null) {
        notification('Please select a valid date!', 'error')
        return
      }
      await axios.post('/api/heroux/CreditSpread/createCreditSpreadDate', {
        curveId: this.curveId,
        evaluationDate: kendo.toString(this.selectedDate, 'yyyy-MM-dd'),
      })
      await this.evaluationDateDataSource.read()
      this.selectedDate = null
      this.edit = false
    },
    async deleteItem() {
      await axios.delete('/api/heroux/CreditSpread/destroyCreditSpreadDate', {
        params: {curveId: this.curveId, evaluationDateOa: this.evaluationDate},
      })
      this.evaluationDateDataSource.read()
    },
    exportToExcel() {
      const url = `/api/heroux/CreditSpread/exportToExcel?curveId=${
        this.curveId
      }&evaluationDateOa=${this.evaluationDate}&t=${this.tokenString}`
      location.href = url
    },
    async createCurveNameDropDown() {
      const vm = this
      return new Promise(function(resolve) {
        let curveNameDropDown = $(vm.$refs.curveNameDropDownList)
          .kendoDropDownList({
            dataTextField: 'curveName',
            dataValueField: 'curveId',
            dataSource: vm.curveDataSource,
            dataBound: function() {
              this.select(0)
              vm.curveId = this.value()
              this.trigger('change')
              resolve(curveNameDropDown)
            },
            change: function() {
              vm.curveId = this.value()
              vm.evaluationDateDataSource.read()
            },
          })
          .data('kendoDropDownList')
      })
    },
    async createEvaluationDateDropDown() {
      const vm = this
      return new Promise(function(resolve) {
        let evaluationDateDropDown = $(vm.$refs.evaluationDateDropDownList)
          .kendoDropDownList({
            dataTextField: 'evaluationDateText',
            dataValueField: 'evaluationDateOa',
            dataSource: vm.evaluationDateDataSource,
            dataBound: function() {
              this.select(0)
              vm.evaluationDate = this.value()
              this.trigger('change')
              resolve(evaluationDateDropDown)
            },
            change: function() {
              vm.evaluationDate = this.value()
              vm.gridDataSource.read()
            },
          })
          .data('kendoDropDownList')
      })
    },
    disableDates(date) {
      return this.evaluationDateDataSource
        .data()
        .some(item => item.evaluationDate == kendo.toString(date, 's'))
    },
  },
}
</script>
